import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import CacheManager from '../../../cache/CacheManager'
import CacheKeys from '../../../cache/CacheKeys'
import LeadDashboardCreateModalUI from './LeadDashboardCreateModalUI'

class LeadDashboardCreateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,

      brandName: '', brandNameError: null,
      accountNamePan: '', accountNamePanError: null,
      comments: '', commentsError: null,
      manualLoanAmount: '', manualLoanAmountError: null,
      poc: '', pocError: null,
      designation: '', designationError: null,
      phoneNumber: '', phoneNumberError: null,
      email: '', emailError: null,
      originatorUserId: '', originatorUserIdError: null,
      channel: '', channelError: null,
    }
  }

  render() {
    return (
      <LeadDashboardCreateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        createEntryMode={this.props.createEntryMode}
        submitted={this.state.submitted}
        onSubmit={this.onSubmit}
        onCancelClick={this.onCancelClick}
        originatorList={this.props.originatorList}
        salesChannelList={this.props.salesChannelList}

        brandName={this.state.brandName}
        onBrandNameChange={(e) => this.setState({ brandName: e.target.value })}
        brandNameError={this.state.brandNameError}
        setBrandNameError={(error) => this.setState({ brandNameError: error })}

        accountNamePan={this.state.accountNamePan}
        onAccountNamePanChange={(e) => this.setState({ accountNamePan: e.target.value })}
        accountNamePanError={this.state.accountNamePanError}
        setAccountNamePanError={(error) => this.setState({ accountNamePanError: error })}

        comments={this.state.comments}
        onCommentsChange={(e) => this.setState({ comments: e.target.value })}
        commentsError={this.state.commentsError}
        setCommentsError={(error) => this.setState({ commentsError: error })}

        manualLoanAmount={this.state.manualLoanAmount}
        onManualLoanAmountChange={(e) => this.setState({ manualLoanAmount: e.target.value })}
        manualLoanAmountError={this.state.manualLoanAmountError}
        setManualLoanAmountError={(error) => this.setState({ manualLoanAmountError: error })}

        poc={this.state.poc}
        onPocChange={(e) => this.setState({ poc: e.target.value })}
        pocError={this.state.pocError}
        setPocError={(error) => this.setState({ pocError: error })}

        designation={this.state.designation}
        onDesignationChange={(e) => this.setState({ designation: e.target.value })}
        designationError={this.state.designationError}
        setDesignationError={(error) => this.setState({ designationError: error })}

        phoneNumber={this.state.phoneNumber}
        onPhoneNumberChange={(e) => this.setState({ phoneNumber: e.target.value })}
        phoneNumberError={this.state.phoneNumberError}
        setPhoneNumberError={(error) => this.setState({ phoneNumberError: error })}

        email={this.state.email}
        onEmailChange={(e) => this.setState({ email: e.target.value })}
        emailError={this.state.emailError}
        setEmailError={(error) => this.setState({ emailError: error })}

        originatorUserId={this.state.originatorUserId}
        onOriginatorUserIdChange={(e) => this.setState({ originatorUserId: e.target.value })}
        originatorUserIdError={this.state.originatorUserIdError}
        setOriginatorUserIdError={(error) => this.setState({ originatorUserIdError: error })}

        channel={this.state.channel}
        onChannelChange={(e) => this.setState({ channel: e.target.value })}
        channelError={this.state.channelError}
        setChannelError={(error) => this.setState({ channelError: error })}
      />
    )
  }

  componentDidMount() {
    Modal.setAppElement('body')
  }

  onCancelClick = () => {
    this.setState({
      successMsg: null, errorList: null, submitted: false,
      brandName: '', accountNamePan: '', comments: '', manualLoanAmount: '',
      poc: '', designation: '', phoneNumber: '', email: '', originatorUserId: '', channel: ''
    })
    this.props.onCreateEntryCancel()
  }

  onSubmit = () => {
    if (this.state.submitted) return

    this.setState({ successMsg: null, errorList: [], submitted: true })

    RestApiUtils.post(this.props.context,
      `/api/su/leadDashboard`,
      this.onSubmitCallback, {
        brandName: this.state.brandName,
        accountNamePan: this.state.accountNamePan,
        comments: this.state.comments,
        manualLoanAmount: this.state.manualLoanAmount ? parseInt(this.state.manualLoanAmount, 10) : null,
        poc: this.state.poc,
        designation: this.state.designation,
        phoneNumber: this.state.phoneNumber,
        email: this.state.email,
        originatorUserId: this.state.originatorUserId,
        channel: this.state.channel,
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    if (response && response.errorList) {
      response.errorList.forEach(error => { errorList.push(error.message) })
    }

    this.setState({ successMsg: response.success, errorList: errorList, submitted: false })

    if (errorList.length === 0) {
      CacheManager.removeObject(CacheKeys.LeadDashboard())
      setTimeout(() => {
        this.setState({ successMsg: null })
        this.onCancelClick()
        this.props.onRefreshClick()
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default withRouter(LeadDashboardCreateModalSF)